export default "__VITE_ASSET__CaPRwp93__"